module.exports = {
	"textures": [
		{
			"image": "helpHand",
			"format": "RGBA8888",
			"size": {
				"w": 101,
				"h": 898
			},
			"scale": 1,
			"frames": [
				{
					"filename": "tap_6.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 97,
						"h": 126
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 97,
						"h": 126
					},
					"frame": {
						"x": 2,
						"y": 2,
						"w": 97,
						"h": 126
					}
				},
				{
					"filename": "tap_5.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 92,
						"h": 121
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 92,
						"h": 121
					},
					"frame": {
						"x": 2,
						"y": 132,
						"w": 92,
						"h": 121
					}
				},
				{
					"filename": "tap_4.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 116
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 116
					},
					"frame": {
						"x": 2,
						"y": 257,
						"w": 90,
						"h": 116
					}
				},
				{
					"filename": "tap_0.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 106
					},
					"frame": {
						"x": 2,
						"y": 377,
						"w": 90,
						"h": 106
					}
				},
				{
					"filename": "tap_1.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 103
					},
					"frame": {
						"x": 2,
						"y": 487,
						"w": 90,
						"h": 103
					}
				},
				{
					"filename": "tap_2.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 100
					},
					"frame": {
						"x": 2,
						"y": 594,
						"w": 90,
						"h": 100
					}
				},
				{
					"filename": "tap_3.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 97
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 97
					},
					"frame": {
						"x": 2,
						"y": 698,
						"w": 90,
						"h": 97
					}
				},
				{
					"filename": "tap_7.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 97
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 97
					},
					"frame": {
						"x": 2,
						"y": 799,
						"w": 90,
						"h": 97
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};